<div class="pageWrapper">
    <router-outlet></router-outlet>
    <app-promo-overlay [isMobile]="isMobile"></app-promo-overlay>
</div>
